import { toast } from "sonner";

const LABELS = {
  "list:created": "hat eine neue Liste angelegt",
  "list:updated": "hat eine Liste bearbeitet",
  "list:deleted": "hat eine Liste gelöscht",
  "entry:created": "hat einen neuen Eintrag hinzugefügt",
  "entry:updated": "hat einen Eintrag aktualisiert",
  "entry:deleted": "hat einen Eintrag gelöscht",
  "entry:vote": 'hat "Will ich auch" markiert',
  "entry:reaction": "hat reagiert",
  "entry:comment": "hat kommentiert",
  "entries:reordered": "hat die Reihenfolge geändert",
  "couple:joined": "ist eurem Space beigetreten",
};

export function partnerToast(event, partnerName) {
  const label = LABELS[event];
  if (!label) return;
  const name = partnerName || "Partner:in";
  toast(`${name} ${label}`, {
    duration: 2500,
    style: { fontFamily: "Manrope, sans-serif" },
  });
}
